import { useTranslation } from '@multaqa/i18n'
import { ScreenSkeleton } from '@multaqa/ui/components/async/screen-skeleton'
import { Logo } from '@multaqa/ui/components/ui/logo'

/**
 * The shell's outer frame, drawn while the `/_authenticated` layout is still
 * loading and `AppShell` is not mounted. Same flex structure, rail width,
 * logo box and top bar height as `app-shell.tsx` and `rail/spine.tsx`, so the
 * boot splash's M flies onto the logo the real shell will show. Decorative:
 * no navigation, no links; the one polite status is the loading label.
 */
export function ShellFrameSkeleton() {
  const { t } = useTranslation()

  return (
    <div
      data-slot="shell-frame-skeleton"
      className="bg-card text-foreground relative flex h-dvh flex-row overflow-hidden"
    >
      <aside
        aria-hidden="true"
        className="bg-basalt text-basalt-foreground relative z-30 flex h-full w-spine shrink-0 flex-col max-[900px]:hidden"
      >
        <div className="border-basalt-border flex h-topbar shrink-0 items-center justify-center border-b">
          <div className="grid h-11 w-12 place-items-center">
            <Logo size={26} tone="reverse" data-boot-target="" />
          </div>
        </div>
      </aside>
      <div aria-hidden="true" className="flex min-w-0 flex-1 flex-col">
        <div className="bg-card border-border flex h-topbar min-w-0 shrink-0 border-b" />
        <main className="min-h-0 flex-1 overflow-y-auto px-page-inset">
          <div className="mx-auto w-full max-w-page">
            <ScreenSkeleton />
          </div>
        </main>
      </div>
      <span role="status" className="sr-only">
        {t('state.loading')}
      </span>
    </div>
  )
}
